// SearchPage.js
import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

function SearchPage() {
    const navigate = useNavigate();
    const location = useLocation();
    
    const [searchTerm, setSearchTerm] = useState(location.state?.keyword || "");

    const handleSearch = (e) => {
        e.preventDefault();
        if (searchTerm.trim()) {
            navigate('/results', { state: { keyword: searchTerm } });
        }
    };

    return (
        <div>
            <h2>Search Page</h2>
            <form onSubmit={handleSearch}>
                <input
                    type="text"
                    placeholder="Search here..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
                <button type="submit">Search</button>
            </form>
        </div>
    );
}

export default SearchPage;